import env from "../../utils/env";
import common from "../../utils/common";

let VouchesService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("vouches/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        create: {
          url: env.getApiUrl("vouches/create"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
          complete: function (e) {
            $("#vouches-grid").data("kendoGrid").dataSource.read();
          }
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { type: "date", editable: false, validation: { required: true } },
            // "code": { nullable: false, validation: { required: true } },
            // "startDate": { type: "date", nullable: false, validation: { required: true } },
            // "expireDate": { type: "date", nullable: false, validation: { required: true } },
            "fullName": { nullable: false, validation: { required: true } },
            "whatWouldYouLikeToSay": { nullable: false, validation: { required: true } },
            "notes": { nullable: false, validation: { required: false } },
            "status": { defaultValue: 0 },
            "referenceType": { defaultValue: 0 },
            "id": {},
            "jugglerId": {},
            "email": { defaultValue: '' },
            "phoneNumber": { defaultValue: '' },
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  return { getDataSource };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`vouches/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if (type == "create") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    delete data.id;
    // data.expireDate = common.converToUtcDate(data.expireDate);
    // data.startDate = common.converToUtcDate(data.startDate);

    console.log("Data::", data);

    return JSON.stringify(data);
  }

  if (type == "update") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    // data.expireDate = common.converToUtcDate(data.expireDate);
    // data.startDate = common.converToUtcDate(data.startDate);

    console.log("Data::", data);

    return JSON.stringify(data);
  }
}

export default VouchesService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/vouches.service.js
 **/